// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flex-file-input-container {
  display: flex;
  flex-direction: row;
}

.file-upload-btn-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.pad-2 {
  padding: 2em;
}

.pad-1 {
  padding: 1em;
}

.border-none {
  border: none !important;
}

.marg-left-1 {
  margin-left: 1em;
}

.modal-header .close {
  border: none;
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/import/components/import.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AACA;EACE,YAAA;AAEF","sourcesContent":[".flex-file-input-container {\n  display: flex;\n  flex-direction: row;\n}\n\n.file-upload-btn-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n\n.pad-2 {\n  padding: 2em;\n}\n\n.pad-1 {\n  padding: 1em;\n}\n\n.border-none {\n  border: none !important;\n}\n\n.marg-left-1 {\n  margin-left: 1em;\n}\n.modal-header .close {\n  border: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
